export default {"src":"/_next/static/media/logo-white.59b13723.svg","height":89,"width":800,"blurWidth":0,"blurHeight":0};